import { FC, ReactText } from "react";
import { motion } from "framer-motion";

import "./GoalConfig.css";

import { NumericInput } from "./NumericInput";
import { TagSwitch } from "./TagSwitch";
import { PrimaryButton } from "./PrimaryLink";
import { Measure, MeasureLabels } from "../utils/context";
import { useCache } from "../utils/useCache";
import { CheckIcon } from "./Icons";

interface GoalConfigProps {
  goal: number;
  onGoalChange: (value: number) => void;
  measure: Measure;
  onMeasureChange: (value: ReactText) => void;
  onSave: () => void;
}

export const GoalConfig: FC<GoalConfigProps> = ({ goal, measure, onGoalChange, onMeasureChange, onSave }) => {
  const { nextStepAnimationSkip } = useCache();

  return (
    <div className="goal-config">
      <motion.div
        className="goal-config__form"
        initial={{
          opacity: nextStepAnimationSkip ? 1 : 0,
          scale: nextStepAnimationSkip ? 1 : 0,
          y: nextStepAnimationSkip ? 0 : 1500
        }}
        animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }}
        transition={{
          duration: 0.5,
          ease: [0.19, 1, 0.22, 1]
        }}
      >
        <NumericInput
          value={goal}
          onChange={onGoalChange}
          onEnter={onSave}
          autoFocus={true}
        />

        <TagSwitch
          options={[
            {
              value: Measure.ML,
              label: MeasureLabels[Measure.ML]
            },
            {
              value: Measure.OZ,
              label: MeasureLabels[Measure.OZ]
            },
          ]}
          selected={measure}
          onChange={onMeasureChange}
        />
        <div className="goal-config__action">
          <PrimaryButton className="goal-config__form__action-button" onClick={onSave}>
            <CheckIcon />
          </PrimaryButton>
        </div>
      </motion.div>
    </div>
  )
}